// The dashboard's interface language (EN / عربي), chosen in the top bar and remembered in
// this browser. The studio follows it today; other screens will as they are translated
// (TASK-036).
import { useEffect, useState } from 'react'

const KEY = 'lj-ui-lang'
const EVENT = 'lj-ui-lang'

export const getUiLang = () => {
  try {
    return localStorage.getItem(KEY) === 'ar' ? 'ar' : 'en'
  } catch (_) {
    return 'en'
  }
}

export const setUiLang = (lang) => {
  const value = lang === 'ar' ? 'ar' : 'en'
  try {
    localStorage.setItem(KEY, value)
  } catch (_) {
    // private mode / blocked storage: still switch for this page
  }
  window.dispatchEvent(new CustomEvent(EVENT, { detail: value }))
}

export function useUiLang() {
  const [lang, setLang] = useState(getUiLang)
  useEffect(() => {
    const onChange = (e) => setLang(e.detail)
    window.addEventListener(EVENT, onChange)
    return () => window.removeEventListener(EVENT, onChange)
  }, [])
  return [lang, setUiLang]
}
